var _rect, _rect2, _rect3, _rect4, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbgLogosinglewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 182,
    viewBox: "0 0 164 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 19,
    width: 91,
    height: 69,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 97,
    width: 91,
    height: 69,
    rx: 10,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 34,
    width: 68,
    height: 57,
    rx: 10,
    fill: "white",
    fillOpacity: 0.65
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 95,
    width: 68,
    height: 57,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5483 147.705C67.7301 147.634 61.782 145.787 56.7038 142.165C51.6257 138.507 47.6839 133.482 44.8786 127.09C42.0732 120.698 40.6705 113.365 40.6705 105.091C40.6705 96.8878 42.1442 89.6435 45.0916 83.358C48.0746 77.0369 52.1761 72.0831 57.3963 68.4964C62.6165 64.9098 68.6179 63.1165 75.4006 63.1165C80.3722 63.1165 84.669 64.0753 88.2912 65.9929C91.9134 67.875 94.9851 70.5028 97.5064 73.8764C100.063 77.25 102.212 81.1207 103.952 85.4886H108.852L110.77 104.878L121.423 146H109.705L99.6903 104.878C99.1577 102.286 98.3409 99.267 97.2401 95.8224C96.1392 92.3778 94.6655 89.022 92.8189 85.755C90.9723 82.4879 88.6108 79.7891 85.7344 77.6584C82.8935 75.4922 79.4489 74.4091 75.4006 74.4091C71.0682 74.4091 67.233 75.723 63.8949 78.3508C60.5568 80.9787 57.9467 84.6186 56.0646 89.2706C54.1825 93.9226 53.2415 99.267 53.2415 105.304C53.2415 111.199 54.1293 116.508 55.9048 121.231C57.6804 125.918 60.1662 129.629 63.3622 132.364C66.5582 135.062 70.2869 136.412 74.5483 136.412C78.4901 136.412 81.9169 135.329 84.8288 133.163C87.7408 130.961 90.1911 128.209 92.1797 124.906C94.1683 121.568 95.7663 118.141 96.9737 114.626C98.2166 111.075 99.1222 107.967 99.6903 105.304L108.639 64.1818H120.358L110.77 105.304L108.852 125.332H104.591C102.744 129.736 100.436 133.642 97.6662 137.051C94.9318 140.425 91.647 143.053 87.8118 144.935C84.0121 146.817 79.5909 147.74 74.5483 147.705Z",
    fill: "url(#paint0_linear_143_210)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_143_210",
    x1: 81.5,
    y1: 0,
    x2: 81.5,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.790625,
    stopColor: "#32229B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbgLogosinglewhite);
export default __webpack_public_path__ + "static/media/IBG Logo single  white.c8c7121a3f968b29c13940efdfb79f86.svg";
export { ForwardRef as ReactComponent };